import { render } from "./DarkModeToggle.vue?vue&type=template&id=f34a5764"
import script from "./DarkModeToggle.vue?vue&type=script&lang=js"
export * from "./DarkModeToggle.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__